import { render, staticRenderFns } from "./AccountTypeSelectionPage.vue?vue&type=template&id=6defdfa3&scoped=true"
import script from "./AccountTypeSelectionPage.vue?vue&type=script&lang=js"
export * from "./AccountTypeSelectionPage.vue?vue&type=script&lang=js"
import style0 from "./AccountTypeSelectionPage.vue?vue&type=style&index=0&id=6defdfa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6defdfa3",
  null
  
)

export default component.exports